import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view05ImageOptions } from './views/exterior_view05'

class X49MK2BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handleTeakOnBathingPlatformChange = this.handleTeakOnBathingPlatformChange.bind(this);
    }

    handleTeakOnBathingPlatformChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnBathingPlatform = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = exterior_view05ImageOptions;

        let image = <ConfiguratorImage boat="X4_9mk2" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='X49 Bathing platform Text' /></p>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X49MK2BathingPlatform);


// WEBPACK FOOTER //
// ./src/X49MK2/X49MK2-BathingPlatform.js